import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Input } from "reactstrap";
import lodash from "lodash"; // library added for debounce functionality
import Ionicon from "react-ionicons";

// components
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import SingleDealerPrimaryReportTable from "../../components/SingleDealerPrimaryReportTable/SingleDealerPrimaryReportTable";
import Pagination from "../../components/Pagination/Pagination";
// import AutoSuggestionDealer from "../../components/AutoSuggestionDealer/AutoSuggestionDealer";

// services
import FleetManagerService from "../../services/FleetManagerService";
import StorageService from "../../services/Storage";
import DashboardService from "../../services/DashboardService";
import HODashboardService from "../../services/HODashaboardService";
// css
import "./PrimaryPointAllDealerReport.css";
import { Roles } from "../../constants/constant.role";
import { formatNumber, generateRandomString } from "../../utils/utils";

const pageSize = 10;

class PrimaryPointAllDealerReport extends Component {
  constructor() {
    super();
    this.state = {
      height: window.innerHeight,
      width: window.innerWidth,
      isLoading: false,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      totalCard: {
        totalPoints: 0,
        totalOfftake: 0,
        totalTbbOfftake: 0,
        totalTbbPoints: 0,
        totalTbrOfftake: 0,
        totalTbrPoints: 0,
      },
      earnedPointQ1: 0,
      totalOfftakeQ1: 0,
      earnedPointQ2: 0,
      totalOfftakeQ2: 0,
      fleets: [],
      totalFleet: 0,
      search: "",
      fmDetail: null,
      dealerRole: null,
      isFmSelected: false,
      yearOptions: [],
      year: null,
      year_name_value: {},
      currentUser: null,
      manageUserLevel: [],
      rolesToDrillDown: [],
    };
    this.searchReport = lodash.debounce(this.searchReport, 500);
  }

  generateRolesToDrillDown = (dealerRole) => {
    let rolesToDrillDown = [];
    if (dealerRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE) {
      rolesToDrillDown = ["ZM", "FM", "Fleet"];
    } else if (dealerRole === Roles.ZONAL_FLEET_MANAGER_ROLE) {
      rolesToDrillDown = ["FM", "Fleet"];
    } else if (dealerRole === Roles.FLEET_MANAGER_ROLE) {
      rolesToDrillDown = ["Fleet"];
    }
    this.setState({ rolesToDrillDown });
  };

  componentDidMount() {
    this.getDisplayLabel();
    const userDetail = StorageService.getUserDetail();
    const { type } = userDetail;
    this.setState({ dealerRole: type });
    window.addEventListener("resize", this.resizeWindow);
    this.generateRolesToDrillDown(type);
    // const { page } = this.state;

    // const fmDetail = this.getCurrentSelectedFmData();
    // this.setState({ fmDetail });
    // if (fmDetail && fmDetail.uuid) {
    //   this.setState({ isFmSelected: true });
    //   this.getAllDealerReport(page, null, null, fmDetail.uuid);
    // } else {
    //   this.getAllDealerReport(page);
    // }
    // const searchParam = this.props.location.search;
    // let memberUuid = null;
    // let dealerName = null;
    // if (searchParam) {
    //   const keys = searchParam.split('&');
    //   const idString = keys[0];
    //   const nameString = keys[1];
    //   const id = idString.split('=');
    //   memberUuid = id[1];
    //   const name = nameString ? nameString.split('=') : null;
    //   dealerName = name ? decodeURI(name[1]) : null;
    //   this.setState({ memberId: memberUuid, memberName: dealerName });
    //   if (memberUuid) {
    //     this.getAllDealerReport(page, null, null, memberUuid);
    //   } else {
    //     this.getAllDealerReport(page);
    //   }
    // } else {
    //   this.getAllDealerReport(page);
    // }

    this.filterAPI();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWindow);
  }

  resizeWindow = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  getAllDealerReport = (page, search, isSearch, uuid) => {
    // if (!uuid && this.state.fmDetail) {
    //   uuid = this.state.fmDetail.uuid;
    // }
    this.setState({ isLoading: true });
    FleetManagerService.getOfftakeScorecardFleet(
      page,
      pageSize,
      search,
      uuid,
      this.state.year
    )
      .then(data => {
        this.setState({ isLoading: false });
        const { fleets, total, total_card } = data.data.data;
        const totalFleet = total;
        const totalPages = Math.ceil(totalFleet / pageSize);
        const totalCard = {
          totalPoints: total_card.total_points || 0,
          totalOfftake: total_card.total_offtake || 0,
          totalTbbOfftake: total_card.total_tbb_offtake || 0,
          totalTbbPoints: total_card.total_tbb_points || 0,
          totalTbrOfftake: total_card.total_tbr_offtake || 0,
          totalTbrPoints: total_card.total_tbr_points || 0,
        }
        this.setState({ fleets, totalFleet, totalPages, totalCard });
      })
      .catch(e => {
        this.setState({ isLoading: false });
        console.error("ERROR", e);
      });
  };

  handlePageChange = page => {
    const { currentUser } = this.state;
    const uuid = currentUser && currentUser.uuid ? currentUser.uuid : null;
    this.setState({ page });
    this.getAllDealerReport(page, null, false, uuid);
  };

  openViewReportPage = (sapId, name, id, type) => {
    const { manageUserLevel, randomKey } = this.state;
    const lastUser = manageUserLevel[manageUserLevel.length - 1];

    let obj = {
      uuid: sapId,
      name,
      role: Roles.FLEET_ROLE,
      type,
    };
    if (lastUser && lastUser.role === Roles.FLEET_ROLE) {
      manageUserLevel[manageUserLevel.length - 1] = obj;
    } else {
      manageUserLevel.push(obj);
    }

    let randomId = null;
    if (randomKey) {
      randomId = randomKey;
    } else {
      randomId = generateRandomString();
    }

    StorageService.setNavigationLevelDetail(randomId, manageUserLevel);

    this.props.history.push(
      `/fleet-report?id=${sapId}&name=${name}&sapid=${encodeURI(id)}&y=${this.state.year
      }`
    );
  };

  searchReport = (search, page) => {
    const { currentUser } = this.state;
    const currentUserId = currentUser && currentUser.uuid ? currentUser.uuid : null;
    this.getAllDealerReport(page, search, true, currentUserId);
  };

  getIndividualFleetManagesFleets = (uuid, name, type) => {
    let { rolesToDrillDown, manageUserLevel } = this.state;
    let length = manageUserLevel.length;
    let role = rolesToDrillDown[length];

    const obj = {
      uuid,
      name
    };
    const currentUser = {
      uuid,
      name,
      role,
      type,
    };
    manageUserLevel.push(currentUser);

    this.setState({ fmDetail: obj, isFmSelected: true, page: 1 });
    this.setState({ page: 1, search: "", currentUser, manageUserLevel });
    // this.searchReport("", 1);
    StorageService.setSelectedFmData(obj);
    this.getAllDealerReport(1, null, null, uuid);
  };

  getDataFromNavigation = (index, manageUserLevel = null) => {
    if (!manageUserLevel) {
      manageUserLevel = this.state.manageUserLevel;
    }
    manageUserLevel = manageUserLevel.slice(0, index);
    const userData = manageUserLevel[index - 1];
    if (userData && userData.uuid) {
      let uuid = userData.uuid;

      this.getAllDealerReport(1, null, null, uuid);
    } else {
      this.getAllDealerReport(1);
    }
    this.setState({
      page: 1,
      currentUser: userData,
      manageUserLevel: manageUserLevel,
    });
  };

  getPageTitle = () => {
    const { dealerRole } = this.state;

    if (dealerRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE) {
      return "Head Office";
    } else if (dealerRole === Roles.ZONAL_FLEET_MANAGER_ROLE) {
      return "Zonal Fleet Manager";
    } else if (dealerRole === Roles.FLEET_MANAGER_ROLE) {
      return "Fleet Manager";
    } else if (dealerRole === Roles.FLEET_ROLE) {
      return "Fleet";
    } else {
      return "";
    }
  };

  openDashboard = () => {
    StorageService.removeSelectedFmData();
    window.scroll(0, 0);
    this.props.history.push("/");
  };

  openReportPage = fmDetail => {
    this.setState({ fmDetail: null, isFmSelected: false, page: 1 }, () => {
      this.getAllDealerReport(1);
    });
    // if (fmDetail && fmDetail.uuid) {
    //   this.props.history.push(`/report?id=${fmDetail.uuid}`);
    // } else {
    //   StorageService.removeSelectedFmData();
    //   this.props.history.push(`/report`);
    // }
  };

  getDisplayLabel = year => {
    DashboardService.getDisplayLabel(this.state.year)
      .then(data => {
        const labels = data.data && data.data.data ? data.data.data : null;

        this.setState({ displayLabels: labels });
      })
      .catch(e => { });
  };

  getCurrentSelectedFmData = () => {
    let data = StorageService.getSelectedFmData();
    data = data ? JSON.parse(data) : null;
    return data;
  };

  filterAPI = () => {
    const { year } = this.state;

    let filter = {
      y: year ? year : null
    };
    this.setState({ isLoader: true });
    HODashboardService.filterAPI(filter)
      .then(res => {
        if (res.data.data) {
          this.setState(
            {
              yearOptions: res.data.data.year ? res.data.data.year : [],
              isLoader: false
            },
            () => {
              if (
                !this.state.year &&
                this.state.yearOptions &&
                this.state.yearOptions[0]
              ) {
                this.setState(
                  {
                    year: this.state.yearOptions[0].value,
                    year_name_value: this.state.yearOptions[0]
                  },
                  () => {
                    const { page } = this.state;
                    const searchParam = this.props.location.search;
                    const query = new URLSearchParams(
                      this.props.location.search
                    );
                    const id = query.get("id");
                    let index = query.get("i");
                    let manageUserLevel = [];

                    this.getDisplayLabel();
                    if (id && index) {
                      index = isNaN(index) === false ? parseInt(index) : 0;
                      manageUserLevel = StorageService.getNavigationLevelDetail(
                        id
                      );
                      // this.setState({ manageUserLevel: manageUserLevel });
                      this.getDataFromNavigation(index, manageUserLevel);
                    } else {
                      this.getAllDealerReport(page);
                    }

                    // if (searchParam) {
                    //   const keys = searchParam.split("=");
                    //   this.setState(
                    //     {
                    //       year: keys[1]
                    //     },
                    //     () => {
                    //       this.getDisplayLabel();
                    //       const { page } = this.state;
                    //       const fmDetail = this.getCurrentSelectedFmData();
                    //       this.setState({ fmDetail });
                    //       if (fmDetail && fmDetail.uuid) {
                    //         this.setState({ isFmSelected: true });
                    //         this.getAllDealerReport(
                    //           page,
                    //           null,
                    //           null,
                    //           fmDetail.uuid
                    //         );
                    //       } else {
                    //         this.getAllDealerReport(page);
                    //       }
                    //     }
                    //   );
                    // } else {
                    //   this.getDisplayLabel();
                    //   const { page } = this.state;
                    //   const fmDetail = this.getCurrentSelectedFmData();
                    //   this.setState({ fmDetail });
                    //   if (fmDetail && fmDetail.uuid) {
                    //     this.setState({ isFmSelected: true });
                    //     this.getAllDealerReport(
                    //       page,
                    //       null,
                    //       null,
                    //       fmDetail.uuid
                    //     );
                    //   } else {
                    //     this.getAllDealerReport(page);
                    //   }
                    // }
                  }
                );
              } else {
                // this.getDisplayLabel();
                // const { page } = this.state;
                // const fmDetail = this.getCurrentSelectedFmData();
                // this.setState({ fmDetail });
                // if (fmDetail && fmDetail.uuid) {
                //   this.setState({ isFmSelected: true });
                //   this.getAllDealerReport(page, null, null, fmDetail.uuid);
                // } else {
                //   this.getAllDealerReport(page);
                // }
                const { page } = this.state;
                const query = new URLSearchParams(this.props.location.search);
                const id = query.get("id");
                let index = query.get("i");
                let manageUserLevel = [];
                // let currentUser = null;
                this.getDisplayLabel();
                index = isNaN(index) === false ? parseInt(index) : 0;
                manageUserLevel = StorageService.getNavigationLevelDetail(id);
                if (id && index) {
                  // this.setState({ manageUserLevel: manageUserLevel });
                  this.getDataFromNavigation(index, manageUserLevel);
                } else {
                  this.getAllDealerReport(page);
                }
              }
            }
          );
          this.props.updateZone();
        }
      })
      .catch(err => {
        this.setState({ isLoader: false });
        console.log("err", err);
      });
  };

  onChangeYear = e => {
    this.setState(
      {
        year: e && e.target && e.target.value
      },
      () => {
        // this.filterAPI();
        // let { yearOptions, year_name_value, year } = this.state;
        // if (year) {
        //   year_name_value = yearOptions.filter(x => x.value == year);
        // }
        // if (year_name_value) {
        //   year_name_value =
        //     year_name_value && year_name_value[0]
        //       ? year_name_value[0]
        //       : year_name_value;
        //   this.setState({ year_name_value });
        //   this.getDisplayLabel(year_name_value.value);
        //   const { page } = this.state;
        //   const fmDetail = this.getCurrentSelectedFmData();
        //   this.setState({ fmDetail });
        //   if (fmDetail && fmDetail.uuid) {
        //     this.setState({ isFmSelected: true });
        //     this.getAllDealerReport(page, null, null, fmDetail.uuid);
        //   } else {
        //     this.getAllDealerReport(page);
        //   }
        // }
        const { page } = this.state;
        const query = new URLSearchParams(this.props.location.search);
        const id = query.get("id");
        let index = query.get("i");
        let manageUserLevel = [];
        // let currentUser = null;
        this.getDisplayLabel();
        if (id && index) {
          index = isNaN(index) === false ? parseInt(index) : 0;
          manageUserLevel = StorageService.getNavigationLevelDetail(id);
          // this.setState({ manageUserLevel: manageUserLevel });
          this.getDataFromNavigation(index, manageUserLevel);
        } else {
          this.getAllDealerReport(
            page,
            null,
            null,
            this.state.currentUser && this.state.currentUser.uuid
              ? this.state.currentUser.uuid
              : null
          );
        }
      }
    );
  };

  handleInputChange = e => {
    const searchVal = e.target.value;
    this.setState({ page: 1, search: searchVal });
    this.searchReport(searchVal, 1);
  };

  render() {
    const {
      fleets,
      totalPages,
      totalFleet,
      search,
      fmDetail,
      dealerRole,
      isFmSelected,
      displayLabels,
      currentUser,
      manageUserLevel,
      totalCard,
    } = this.state;

    const {
      totalPoints,
      totalOfftake,
      totalTbbOfftake,
      totalTbbPoints,
      totalTbrOfftake,
      totalTbrPoints,
    } = totalCard || {};
    const pageTitle = this.getPageTitle();

    const isSearchShow = dealerRole === Roles.HEAD_OFFICE_BAADSHAH_ROLE && (!currentUser) ? false : true;

    const manageUserLevelLength = manageUserLevel ? manageUserLevel.length : 0;
    console.log("manageUserLevel", manageUserLevel)
    const navigation = this.state.manageUserLevel.map((m, index) => (
      <>
        <span>
          <Ionicon icon="ios-arrow-forward" fontSize="34px" color="#fdbb1f" />
        </span>
        {index !== manageUserLevelLength - 1 && (
          <span
            className="prev-page-link cursor-pointer title-case"
            onClick={this.getDataFromNavigation.bind(this, index + 1, null)}
          >
            Details for {m.name} ({m.role})
          </span>
        )}
        {index === manageUserLevelLength - 1 && (
          <span className="current-page title-case">
            Details for {m.name} ({m.role})
          </span>
        )}
      </>
    ));

    const prepareDealerCard = fleets.map(d => {
      return (
        <SingleDealerPrimaryReportTable
          dealer={d}
          openViewReportPage={this.openViewReportPage}
          getIndividualFleetManagesFleets={this.getIndividualFleetManagesFleets}
          dealerRole={dealerRole}
          isFmSelected={isFmSelected}
          currentUser={currentUser}
        />
      );
    });
    return (
      <div id="primary-point-all-delear-report">
        {/* <Container> */}
        {this.state.isLoading && <CustomSpinner></CustomSpinner>}
        {manageUserLevel.length > 0 && (
          <Row>
            <Col>
              <span
                className="prev-page-link cursor-pointer"
                onClick={this.getDataFromNavigation.bind(this, 0, null)}
              >
                Points report for truck / bus
              </span>
              {navigation}
              {/* <span>
              <Ionicon icon="ios-arrow-forward" fontSize="34px" color="#fdbb1f" />
            </span>
            <span className="current-page">Report of {delearName}</span> */}
            </Col>
          </Row>
        )}

        <Row
        // style={{ marginBottom: "-18px", marginTop: "-4px" }}
        >
          {navigation.length < 1 ? (
            <Col
              xl={isSearchShow ? 6 : 7}
              className="current-page"
              md={this.state.yearOptions.length > 1 ? "6" : "9"}
              xs="12"
              style={{ top: "7px" }}
            >
              Offtake Scorecard Of {pageTitle} (
              {displayLabels && displayLabels.year_till_previous_quarter})
            </Col>
          ) : (
            <Col
              xl={6}
              md={this.state.yearOptions.length > 1 ? "6" : "9"}
              xs="12"
            ></Col>
          )}
          {this.state.yearOptions.length > 1 && (
            <Col xl={isSearchShow ? "3" : "5"} md={isSearchShow ? "4" : "5"} xs="12" style={{ paddingLeft: "0px", display: "flex", justifyContent: "flex-end", paddingRight: "30px" }}>
              <Row className="text-right">
                <div className="fin-label mt-2">Financial Year</div>
                &nbsp;
                <FormGroup>
                  <select
                    name="month"
                    className="form-control cursor-pointer"
                    value={this.state.year}
                    style={{
                      fontSize: "13px",
                      width: "110px",
                      color: "#6e777f",
                      marginLeft: "auto"
                    }}
                    onChange={e => {
                      this.onChangeYear(e);
                    }}
                  >
                    {this.state.yearOptions.map(item => (
                      <option value={item.value} selected>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
              </Row>
            </Col>
          )}
          {isSearchShow && (
            <Col md="3" xs="12">
              {/* <AutoSuggestionDealer
              {...this.props}
              HOD={false}
              year={this.state.year}
            /> */}
              <Input
                type="text"
                name="search"
                id="search"
                placeholder={(dealerRole === Roles.FLEET_MANAGER_ROLE || (currentUser && currentUser.role && currentUser.role === "FM")) ? "Search using fleet name and member id" : "Search by name or fm email"}
                className="login-input"
                value={search || ''}
                onChange={this.handleInputChange}
              />
              <div>
                <img src="images/search.svg" className="report-search" alt='search'></img>
              </div>
            </Col>
          )}
        </Row>

        {/* <br /> */}
        {/* <div className="showingText">
          Financial Year{" "}
          {this.state.year_name_value && this.state.year_name_value.name}.
        </div> */}

        <Row className="margin-top-30 reportCard">
          <Col xl="4">
            <Card className="card-bg-image">
              <CardBody>
                <Row className="card-margin">
                  <Col xs="3">
                    <img src="images/wallet.svg" alt="" className="card-icon" />
                  </Col>
                  <Col xs="9" className="card-content-center  mt-0">
                    <Row className="card-point-header">
                      <Col xs="6" className="padding-2">
                        Total Offtake
                      </Col>
                      <Col xs="6" className="padding-2">
                        Total Points
                      </Col>
                    </Row>
                    <Row className="card-point-value">
                      <Col xs="6" className="padding-2">
                        {formatNumber(totalOfftake)}
                      </Col>
                      <Col xs="6" className="padding-2">
                        {formatNumber(totalPoints)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card>
              <CardBody>
                <Row className="card-margin">
                  <Col xs="3">
                    <img src="images/calendar.svg" alt="" className="card-icon" />
                  </Col>
                  <Col xs="9" className="card-content-center  mt-0">
                    <Row className="card-point-header">
                      <Col xs="6" className="padding-2">
                        TBB Offtake
                      </Col>
                      <Col xs="6" className="padding-2">
                        TBB Points
                      </Col>
                    </Row>
                    <Row className="card-point-value">
                      <Col xs="6" className="padding-2">
                        {formatNumber(totalTbbOfftake)}
                      </Col>
                      <Col xs="6" className="padding-2">
                        {formatNumber(totalTbbPoints)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card>
              <CardBody>
                <Row className="card-margin">
                  <Col xs="3">
                    <img src="images/calendar.svg" alt="" className="card-icon" />
                  </Col>
                  <Col xs="9" className="card-content-center  mt-0">
                    <Row className="card-point-header">
                      <Col xs="6" className="padding-2">
                        TBR Offtake
                      </Col>
                      <Col xs="6" className="padding-2">
                        TBR Points
                      </Col>
                    </Row>
                    <Row className="card-point-value">
                      <Col xs="6" className="padding-2">
                        {formatNumber(totalTbrOfftake)}
                      </Col>
                      <Col xs="6" className="padding-2">
                        {formatNumber(totalTbrPoints)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {prepareDealerCard}
        {fleets.length === 0 && (
          <Card className="mt-2">
            <CardBody className="text-align-center card-point-header">
              We could not find any fleet with matching search criteria.
            </CardBody>
          </Card>
        )}
        {totalFleet > 0 && (
          <Pagination
            margin={2}
            page={this.state.page}
            count={totalPages}
            pageSize={pageSize}
            totalRecords={totalFleet}
            onPageChange={this.handlePageChange}
          />
        )}
      </div>
    );
  }
}

export default PrimaryPointAllDealerReport;
